import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";

export default function Page({ slug: fixedSlug }) {
  const params = useParams();
  const slug = fixedSlug || params.slug;
  const [page, setPage] = useState(undefined);

  useEffect(() => {
    setPage(undefined);
    api.get(`/pages/${slug}`).then(({ data }) => setPage(data)).catch(() => setPage(null));
  }, [slug]);

  if (page === undefined) return <main className="max-w-4xl mx-auto px-6 py-32 text-center brand-muted">A carregar...</main>;
  if (page === null) {
    return (
      <main className="max-w-4xl mx-auto px-6 py-32 text-center" data-testid="page-not-found">
        <h1 className="font-serif text-4xl brand-text mb-4">Página não encontrada</h1>
        <Link to="/" className="btn-primary mt-6 inline-flex">Voltar ao início</Link>
      </main>
    );
  }

  return (
    <main data-testid={`cms-page-${page.slug}`}>
      <section className="max-w-4xl mx-auto px-6 lg:px-12 py-24">
        <p className="label-sm mb-3">Au and Co.</p>
        <h1 className="font-serif text-5xl lg:text-6xl brand-text mb-10" data-testid="cms-page-title">{page.title}</h1>
        {page.image_url && (
          <img src={page.image_url} alt={page.title} className="w-full max-h-[420px] object-cover mb-10 brand-border border" />
        )}
        <div
          className="prose prose-lg brand-muted max-w-none leading-relaxed"
          data-testid="cms-page-body"
          dangerouslySetInnerHTML={{ __html: page.body_html || "" }}
        />
        <Link to="/loja" className="btn-primary mt-12 inline-flex">Descobrir a coleção</Link>
      </section>
    </main>
  );
}
